import React from 'react'
import heroImage from '../../assets/images/optimized/r-front-wide.webp';
import LinkToReservation from './components/link-to-reservation/link-to-reservation';
import AboutUs from './components/about-us/about-us';
import ShowcaseVisby from './components/showcase-visby/showcase-visby';
import ShowcaseHotel from './components/showcase-hotel/showcase-hotel';

import './home.css';

const Home = () => {
  return (
    <main className='route home'>
      <div className="hero_image">
        <img src={heroImage} alt="Ringarens Lägenhetshotell" />
        <h2>Varmt välkommen till<br/>Ringarens Lägenhetshotell</h2>
        {/* TODO: Quick way to reservation */}
        {/* <div className="link-wrapper">
          <LinkToReservation />
        </div> */}
      </div>

      <AboutUs />

      <ShowcaseHotel />

      <ShowcaseVisby />
      
    </main >
  )
}

export default Home